function getWebSocketHost() {
    if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
        return window.location.protocol === 'https:' ? `wss://${window.location.host}` : `ws://${window.location.host}`;
    }
    return 'ws://localhost';
}
export const WSS_HOST = getWebSocketHost();
export const WSS_PATH = {
    editor: '/socket.io',
};
export const DEFAULT_SOCKET_OPTS = {
    transports: ['websocket'],
    // 重新连接时使用的随机因子（例如，这样客户端在服务器崩溃后不会在同一时间重新连接）
    randomizationFactor: 0.35,
    // 重新连接前的初始延迟（以毫秒为单位）（受 randomizationFactor 值影响）。
    reconnectionDelay: 2 * 1000,
    // 两次重新连接尝试之间的最大延迟。每次尝试都会将重新连接延迟增加 2 倍。
    reconnectionDelayMax: 5000,
};
